import { render } from "./App.vue?vue&type=template&id=9ff8b46a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9ff8b46a&lang=scss"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__